import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      logo: "SuperPosition",
      subtitle: "Discover the answers with the power of Qimen",
      moodButton: "See the mood today",
      questionButton: "Got question inside your mind",
      gameButton: "Psychological Test",
      searchPlaceholder: "What is your question?",
      backButton: "Back",
      searchInputAria: "Search input field",
      searchButtonAria: "Submit search",
      backButtonAria: "Go back to main menu",
      moodResultTitle: "Today's Cosmic Insight",
      loadingMood: "Reading the cosmic energies...",
      viewCards: "Click to view your reading",
      searchInstructions: "Hint: Calm your mind, think about your most pressing question, and then enter your thoughts below. The more specific, the more insightful the answer will be.",
      date: "Date",
      lunar: "Lunar",
      weekday: "Weekday",
      festival: "Festival",
      bazi: "Bazi",
      season: "Season",
      zodiacConflict: "Zodiac Conflict",
      constellation: "Constellation",
      starPosition: "Star Position",
      pengzuTaboosSimple: "Pengzu Taboos Simple",
      twelveSpirits: "Twelve Spirits",
      auspiciousDirections: "Auspicious Directions",
      suitable: "Suitable",
      forbidden: "Forbidden",
      calendarTitle: "Today's Calendar",
      gridButton: "Nine Palace Grid",
      gridPageTitle: "Nine Palace Grid",
      gridPageSubtitle: "Ancient wisdom displayed in the sacred nine palace formation",
      refreshGrid: "Refresh Grid",
      refresh: "Refresh",
      loadingGrid: "Loading cosmic grid...",
      gridErrorMessage: "Failed to load grid data. Please try again.",
      retry: "Try Again",
      statusActive: "Active",
      statusNeutral: "Neutral",
      statusInactive: "Inactive",
      gridDetails: "Grid Details",
      basicInfo: "Basic Information",
      gridName: "Grid Name",
      innateGridName: "Innate Grid",
      gridAttribute: "Grid Attribute",
      innateAttribute: "Innate Attribute",
      elementAttributes: "Element Attributes",
      godAttribute: "God",
      starAttribute: "Star",
      doorAttribute: "Door",
      monthAttribute: "Month",
      statusInformation: "Status Information",
      monthToDoor: "Month to Door",
      gridToDoor: "Grid to Door",
      starToMonth: "Star to Month",
      starToGrid: "Star to Grid",
      earthBranch: "Earth Branch",
      twelveLifeCycle: "Twelve Life Cycle",
      comingTwelveLifeCycle: "Coming Twelve Life Cycle",
      patterns: "Patterns",
      loadingText: "Loading...",
      generalPattern: "General Pattern",
      clickForDetails: "Click for details",
      chineseCalendar: "Chinese Calendar",
      lunarCalendarDetails: "Lunar Calendar Details",
      selectDateTime: "Select Date and Time",
      dateTimeLabel: "Date and Time",
      zodiac: "Zodiac",
      star: "Star",
      naYin: "NaYin",
      currentSeason: "Current Season",
      nextSeason: "Next Season",
      pengzuTaboos: "Pengzu Taboos",
      goodSpirits: "Good Spirits",
      badSpirits: "Bad Spirits",
      todayFestival: "Today's Festival",
      wish: "Wish you all the best",
      ninePalaceGrid: "Qimen Nine Palace Grid",
      activities: "Do and Don't",
      calendarWish: "Harmony with the universe",
      spirits: "Spirits",
      gridWish: "Qimen Nine Palace, Mystical Secrets",
      solutions: "Solutions",
      loadingTitle: "Loading Magic...",
      loadingSubtitle: "Preparing your mystical journey",
      twelveGod: "Twelve Gods",
      twelveBuildingDay: "Twelve Building Days",
      // Game page translations
      game: {
        title: "Love Fortune",
        subtitle: "Want to know when your love life will explode? Try this super fun Qimen fortune game!",
        back: "Back",
        inputPlaceholder: "Enter your question or thought...",
        confirm: "Reveal Fortune",
        loading: "Reading your fortune...",
        yourFortune: "Your Love Fortune",
        pleaseEnterText: "Please enter some text",
        apiError: "Love goddess and moon god are busy, please try again later.",
        inputError: "Love goddess said: Please enter 6 digits.",
        gamePlaceholder: "Your love number",
        getReading: "Reveal Love Fortune",
        viewResult: "View Your Reading",
        instruction_title: "🎯 How to Play:",
        instruction_1: "✨ Take a deep breath and focus on your love life",
        instruction_2: "🔮 Look at the mystical image above carefully",
        instruction_3: "🔢 Find and write down the first 6 numbers you see",
        instruction_4: "💝 Numbers can repeat (like \"126690\")",
        instruction_5: "💬 Enter the numbers in the input field below!",
        instruction_6: "🚀 Click \"Reveal Love Fortune\" to discover your love fortune!",
      }
    }
  },
  zh: {
    translation: {
      logo: "SuperPosition",
      subtitle: "讓奇門遁甲告訴你答案",
      moodButton: "查看今日運勢",
      questionButton: "為心中疑惑尋找答案",
      gameButton: "心理測驗",
      searchPlaceholder: "您的問題？",
      backButton: "返回",
      searchInputAria: "輸入框",
      searchButtonAria: "提交",
      backButtonAria: "返回主選單",
      moodResultTitle: "今日能量狀態",
      loadingMood: "讀取能量...",
      viewCards: "點擊查看你的能量狀態",
      searchInstructions: "提示： 先靜心，默想你心中最迫切的問題，然後在以下輸入你心中所想，越具體，答案越精準。",
      date: "日期",
      lunar: "農曆",
      weekday: "星期",
      festival: "今日節日",
      bazi: "八字",
      season: "季節",
      zodiacConflict: "生肖沖煞",
      constellation: "星座",
      starPosition: "星次",
      pengzuTaboosSimple: "彭祖百忌",
      twelveSpirits: "十二神",
      auspiciousDirections: "吉神方位",
      suitable: "宜",
      forbidden: "忌",
      calendarTitle: "今日黃曆",
      gridButton: "九宮格",
      gridPageTitle: "奇門遁甲",
      gridPageSubtitle: "古老智慧的神聖奇門九宮方位展示",
      refreshGrid: "重新整理奇門九宮",
      refresh: "重新整理",
      loadingGrid: "載入奇門九宮...",
      gridErrorMessage: "載入九宮格資料失敗，請重試。",
      retry: "重試",
      statusActive: "旺相",
      statusNeutral: "中性",
      statusInactive: "休囚/衰弱",
      // Grid Detail Modal translations
      gridDetails: "九宮格詳情",
      basicInfo: "基本資訊",
      gridName: "宮位名稱",
      innateGridName: "先天宮位",
      gridAttribute: "宮位屬性",
      innateAttribute: "先天屬性",
      elementAttributes: "五行屬性",
      godAttribute: "神",
      starAttribute: "星",
      doorAttribute: "門",
      monthAttribute: "月",
      statusInformation: "狀態資訊",
      monthToDoor: "月令對八門",
      gridToDoor: "九宮對八門",
      starToMonth: "九星對月令",
      starToGrid: "九星對九宮",
      earthBranch: "地支",
      twelveLifeCycle: "十二長生",
      comingTwelveLifeCycle: "後天十二長生",
      patterns: "格局",
      loadingText: "載入中...",
      generalPattern: "格局",
      clickForDetails: "點擊查看詳情",
      chineseCalendar: "中國農曆",
      lunarCalendarDetails: "農曆詳情",
      selectDateTime: "選擇日期和時間",
      dateTimeLabel: "日期和時間",
      zodiac: "生肖",
      star: "星次",
      naYin: "納音",
      currentSeason: "當前節氣",
      nextSeason: "下一節氣",
      pengzuTaboos: "彭祖百忌",
      goodSpirits: "今日吉神",
      badSpirits: "今日凶煞",
      todayFestival: "今日節日",
      wish: "祝您諸事順遂",
      ninePalaceGrid: "奇門九宮",
      activities: "宜忌事項",
      calendarWish: "天人合一，順應自然",
      spirits: "神煞",
      gridWish: "奇門九宮，玄機妙理",
      solutions: "化解方法",
      loadingTitle: "載入中...",
      loadingSubtitle: "準備你的神秘旅程",
      twelveGod: "十二值神",
      twelveBuildingDay: "十二建日",
      // Game page translations
      game: {
        title: "奇門遁甲愛情占卜",
        subtitle: "想知道愛情運勢何時大爆發？快來試試這超有趣的奇門占卜！🔮",
        back: "返回",
        inputPlaceholder: "輸入你的問題或想法...",
        confirm: "揭示運勢",
        loading: "正在讀取你的運勢...",
        yourFortune: "你的愛情運勢",
        pleaseEnterText: "請輸入一些文字",
        apiError: "愛神和月老在忙，請稍後再過來～",
        inputError: "月老叫我跟你說：要6個數字喔！",
        gamePlaceholder: "你的愛情數字",
        getReading: "獲取愛情運勢",
        viewResult: "查看愛情運勢",
        instruction_title: "🎯 如何奇門占卜：",
        instruction_1: "✨ 深呼吸一口氣，想像你未來一週的愛情",
        instruction_2: "🔮 盯著下面這張圖，記下你第一眼看到的6個數字！",
        instruction_3: "🔢 數字可以重複喔～就像「126690」這樣~",
        instruction_4: "💬 直接填在下方的輸入框內！",
        instruction_5: "💝 點擊「獲取愛情運勢」來發現你的運勢！",
        instruction_6: "🚀 說不定愛神就在轉角等你！😘💕",
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    debug: false,
    
    detection: {
      // Only respect explicit user/storage choice; otherwise fall back to zh
      order: ['localStorage', 'sessionStorage', 'querystring', 'cookie'],
      caches: ['localStorage', 'sessionStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
    },

    supportedLngs: ['zh', 'en'],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 